import React from "react";
import { Grid, Row, SpacedCol } from "../grid";
import Progress from "../progress";
import { useWrContext } from "../wr-context";
export var WorkflowLoadStateManager = function(param) {
    var children = param.children, _loadWhile = param.loadWhile, loadWhile = _loadWhile === void 0 ? "initialization" : _loadWhile;
    var ref;
    var context = useWrContext();
    var workflow = context.state.workflow;
    var isDone = workflow && ((ref = workflow.getCurrentUnit()) === null || ref === void 0 ? void 0 : ref.id) !== loadWhile;
    if (isDone) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
    } else {
        return /*#__PURE__*/ React.createElement(Grid, {
            fluid: true
        }, /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(SpacedCol, {
            xs: 12
        }, /*#__PURE__*/ React.createElement(Progress, null))));
    }
};
export default WorkflowLoadStateManager;
